// extracted by mini-css-extract-plugin
export default {"ShareBody":"shareModal_ShareBody__3rb1v","ShareBox":"shareModal_ShareBox__3Hd-S","ShareTips":"shareModal_ShareTips__m1XK-"};